import { SuggestedServiceModel } from 'src/app/models/coe/suggested-service';
import { Component, HostListener, OnInit } from '@angular/core';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { EMPTY } from 'rxjs';
import { BasePage } from 'src/app/pages/base-page/base-page';
import { RecommendedServiceService } from 'src/app/pages/services/recommended-service.service';
import { PageableResponse, SocietiesService } from '@pwc-bei/common';
import { Logger } from '@nsalaun/ng-logger';
import { CustomerProfileService } from 'src/app/pages/services/customer-profile.service';
import { UserProfile } from 'src/app/pages/user-profile/models/user-profile';
import { Router } from '@angular/router';

@Component({
    selector: 'app-recommended-services',
    templateUrl: './recommended-services.component.html',
    styleUrls: ['./recommended-services.component.scss'],
    standalone: false
})
export class RecommendedServicesComponent extends BasePage implements OnInit {
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;

  recommendedService: SuggestedServiceModel[] = [];
  customerId: string;
  societyId?: number;

  response: SuggestedServiceModel[] = [];
  
  @HostListener("window:orientationchange", [])
  @HostListener("window:resize", []) 
  updatePageSize() {
    // lg (for laptops and desktops - screens equal to or greater than 1200px wide)
    // md (for small laptops - screens equal to or greater than 992px wide)
    // sm (for tablets - screens equal to or greater than 768px wide)
    // xs (for phones - screens less than 768px wide)
    let previousPageSize = this.pageSize;
    if (window.innerWidth >= 1000) {
      this.pageSize = 5; // lg
    } else if (window.innerWidth  >= 768) {
      this.pageSize = 2;//sm
    } else if (window.innerWidth < 768) {
      this.pageSize = 1;//xs
    }
    if(previousPageSize !== this.pageSize) {
      this.recommendedService = this.recommendedService.slice(0, this.pageSize-1);
      this.changePage(this.currentPage);
    }
  }

private swipeCoord?: [number, number];
private swipeTime?: number;

swipe(e: TouchEvent, when: string): void {
  const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
  const time = new Date().getTime();

  if (when === 'start') {
    this.swipeCoord = coord;
    this.swipeTime = time;
  } else if (when === 'end') {
    const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
    const duration = time - this.swipeTime;

    if (duration < 1000 //
      && Math.abs(direction[0]) > 30 // Long enough
      && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
        if(direction[0] < 0 && this.currentPage<(this.totalPage.length)) {
          this.currentPage+=1;
          this.changePage(this.currentPage);
        } else if(direction[0] < 0 && this.currentPage==(this.totalPage.length-1)) {
          this.currentPage=0;
          this.changePage(this.currentPage);
        } else if(this.currentPage>0) {
          this.currentPage-=1;
          this.changePage(this.currentPage);
        } else if(this.currentPage==0) {
          this.currentPage=(this.totalPage.length-1);
          this.changePage(this.currentPage);
        }
    }
  }
}

  totalPage = [];
  currentPage = 0;
  constructor(
    private societyService: SocietiesService,
    private suggestedServicesService: RecommendedServiceService,
    private logger: Logger,
    private customerProfileService: CustomerProfileService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    if (window.innerWidth >= 1000) {
      this.pageSize = 5; // lg
    } else if (window.innerWidth  >= 768) {
      this.pageSize = 2;//sm
    } else if (window.innerWidth < 768) {
      this.pageSize = 1;//xs
    }
    this.retrieveRecomendedService();
  }

  changePage(i: number) {
    this.currentPage = i;
    this.retrieveRecomendedService();
    return EMPTY;
  }

  retrieveRecomendedService() {
    if (this.societyId && this.customerId) {
      this.suggestedServicesService
        .findAll(
          this.customerId,
          this.societyId,
          undefined,
          this.currentPage,
          this.pageSize,
          undefined,
          undefined,
          true,
          true,
          undefined,
          undefined,
          true,
        )
        .subscribe({
          next: (data: PageableResponse<SuggestedServiceModel[]>) => {

            this.recommendedService = data.content;
            this.currentPage = data.pageable.pageNumber;
            this.totalPage = Array(Math.ceil(data.totalElements / this.pageSize))
              .fill(0)
              .map((x, i) => i);
          }, error: (error) => {
            this.logger.error(error);
          },
        });
    } else {
      var obs = this.societyService.currentSociety$.subscribe((society) => {
        if (society && society != undefined) {
          if (obs) {
            obs.unsubscribe();
          }
          this.societyId = society.id;
          this.customerProfileService
            .getMyProfile()
            .subscribe((profile: UserProfile) => {
              this.customerId = profile.id;
              this.suggestedServicesService
                .findAll(
                  this.customerId,
                  this.societyId,
                  undefined,
                  this.currentPage,
                  this.pageSize,
                  undefined,
                  undefined,
                  true,
                  true,
                  undefined,
                  undefined,
                  true,
                )
                .subscribe({
                  next: (data: PageableResponse<SuggestedServiceModel[]>) => {
                    this.recommendedService = data.content;
                    this.currentPage = data.pageable.pageNumber;
                    this.totalPage = Array(Math.ceil(data.totalElements / this.pageSize))
                      .fill(0)
                      .map((x, i) => i);
                  }, error: (error) => {
                    this.logger.error(error);
                  },
                });
            });
        }
      });
    }
  }

  goToService(service: SuggestedServiceModel) {
    this.router.navigate([
      this.RoutePath.THEMATIC_AREA,
      service.area.toLowerCase(),
      service.serviceId,
    ]);
  }
}
